import { Button } from "@mui/material";
import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getIdBlog, getListBlog } from "../../redux/actions/actionBlog";

function Blog() {
    const navigate = useNavigate();
    const { getListBlogResult, getListBlogLoading, getListBlogError } =
        useSelector((state) => state.indexReducerBlog);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getListBlog());
    }, [dispatch]);

    const handleDetail = (idk) => {
        navigate(`/Blog/${idk.judul.replace(/ /g, "-")}`);
        dispatch(getIdBlog(idk));
    };

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            slidesToSlide: 3,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
            slidesToSlide: 2,
        },
        mobile: {
            breakpoint: { max: 600, min: 0 },
            items: 1,
            slidesToSlide: 1,
        },
    };
    return (
        <>
            <section className="section" id="blog">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-heading mb-5">
                                <h3 className="text-dark mb-1 fw-light text-uppercase">
                                    Blog
                                </h3>
                                <div className="title-border-simple position-relative"></div>
                            </div>
                        </div>
                    </div>
                    <div className="row my-3">
                        <Carousel
                            swipeable={false}
                            draggable={false}
                            responsive={responsive}
                            ssr={true}
                            infinite={true}
                            autoPlaySpeed={1000}
                            keyBoardControl={true}
                            customTransition="all .5"
                            transitionDuration={500}
                            containerClass="carousel-container"
                            dotListClass="custom-dot-list-style"
                            itemClass="carousel-item-padding-40-px"
                            className="carousel-responsive"
                        >
                            {getListBlogResult ? (
                                getListBlogResult.map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className="card-blog mx-2"
                                        >
                                            <Card className="card-content">
                                                <Card.Img
                                                    className="img-header"
                                                    variant="top"
                                                    src={item.img_url}
                                                />
                                                <Card.Body>
                                                    <Card.Text className="text-date mb-1">
                                                        {item.createAt}
                                                    </Card.Text>
                                                    <Card.Title
                                                        onClick={() => {
                                                            handleDetail(item);
                                                        }}
                                                        className="text-hidden-content-judul"
                                                    >
                                                        {item.judul}
                                                    </Card.Title>

                                                    <Card.Text className="text-hidden-content-deskripsi">
                                                        {item.deskripsi}
                                                    </Card.Text>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => {
                                                            handleDetail(item);
                                                        }}
                                                    >
                                                        Detail
                                                    </Button>
                                                </Card.Body>
                                            </Card>
                                        </div>
                                    );
                                })
                            ) : getListBlogLoading ? (
                                <>
                                    <p> Loading data...</p>
                                </>
                            ) : (
                                <p>
                                    {getListBlogError
                                        ? getListBlogLoading
                                        : "data..."}
                                </p>
                            )}
                        </Carousel>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Blog;
